export const oneTrustElementId = "onetrust-consent-sdk";
export const signUpAndWinElementId = "bx-campaign-2251512";
export const beforeYouGoElementId = "bx-campaign-2251523";
